import { getWebAbsPath } from '../../../util/path';

const useRetainerSubOpts = () => {
    const getWireOptImg = (opt) => {
        let path = '/img/retainerImg/wireOpts/';
        switch (opt) {
            case 'Round Twist Wire':
                path += '9.round_twist.png';
                break;
            case 'Flat Twist Wire':
                path += '8.flat_twist.png';
                break;
            default:
                path = '/img/check.png';
                break;
        }
        return getWebAbsPath(path);
    };

    return {
        getWireOptImg,
    };
};

export default useRetainerSubOpts;
